import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { customerBalanceReportSearchSchema } from '@/lib/services/reports/reports.schema'

export const Route = createFileRoute('/_authenticated/$orgId/reports/customer-balances')({
  validateSearch: (search) => customerBalanceReportSearchSchema.parse(search),
  beforeLoad: ({ context, params, search }) => {
    if (!context.ability.can('list', 'transactions')) throw notFound()
    if (+params.orgId === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)) {
      throw redirect({ to: '/$orgId/reports', params, replace: true })
    }
    throw redirect({ to: '/$orgId/money/customer-balances', params, search, replace: true })
  },
})
